export interface CollaboratorSearchResult {
  email: string;
  name: string;
}

/** Typeahead over registered accounts, so collaborators can only be added from
 *  people who actually have an account. Same-origin (sends the session cookie).
 *  Returns [] for queries under 2 chars or on any error. */
export const searchCollaborators = async (
  query: string,
): Promise<Array<CollaboratorSearchResult>> => {
  const q = query.trim();
  if (q.length < 2) return [];
  try {
    const response = await fetch(`/api/collaborators/search?q=${encodeURIComponent(q)}`);
    if (!response.ok) return [];
    const data = (await response.json()) as { users?: Array<CollaboratorSearchResult> };
    return data.users ?? [];
  } catch {
    return [];
  }
};
